<app-user-access
  [setColleaguesFromState]="colleaguesFromState$ | ngrxPush"
  [setCurrentUserAccess]="currentUserAccess$ | ngrxPush"
  [setCurrentUser]="currentUser$ | ngrxPush"
  [setGroupAccess]="groupAccess$ | ngrxPush"
  [setIsLoading]="isLoading$ | ngrxPush"
  [setLoadingPresentation]="loadingPresentation$ | ngrxPush"
  [setLastFailedStaffAccessCreateUserId]="lastFailedStaffAccessCreateUserId$ | ngrxPush"
  [setStoresFromState]="storesFromState$ | ngrxPush">
</app-user-access>

